import InputComponent from "components/InputG";
import { useState } from "react";
import * as S from "./styles";

interface IPesquisarCorretorProps {
  onChangePalavraChave: (value: string) => void;
  refetchListarFila: () => void;
}
const PesquisarCorretor = ({
  onChangePalavraChave,
  refetchListarFila,
}: IPesquisarCorretorProps) => {
  const [palavraChave, setPalavraChave] = useState("");
  const handlePesquisar = async () => {
    await onChangePalavraChave(palavraChave);
    refetchListarFila();
  };

  return (
    <S.Content>
      <S.Row>
        <S.Column style={{ width: "624px" }}>
          <S.Subtitle>Pesquisar corretor</S.Subtitle>
          <InputComponent
            onChange={(e) => {
              const { value } = e.target;
              setPalavraChave(value);
              onChangePalavraChave(value);
            }}
            value={palavraChave}
            placeholder="Digite o nome do corretor"
            borderRadius="8px"
            buttonAction={() => {
              handlePesquisar();
            }}
            onKeyPress={(e) => e.key === "Enter" && handlePesquisar()}
          />
        </S.Column>
      </S.Row>
    </S.Content>
  );
};
export default PesquisarCorretor;
